import { useQuery } from '@tanstack/react-query';

import {
  getInsurancePoliciesForParty,
  type GetInsurancePoliciesForPartyResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function usePolicies(
  partyId: string,
  filter?: { activeOnly?: boolean },
  options?: QueryOptions<GetInsurancePoliciesForPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.policies.list(partyId, filter),
    queryFn: async () => {
      const result = await getInsurancePoliciesForParty(
        { path: { party_id: partyId } },
        wgApi,
      );

      if (filter?.activeOnly)
        return result.items.filter((item) => item.status === 'ACTIVE');

      return result.items;
    },
    ...options,
  });
}
